import { FunctionComponent, useEffect, useState } from 'react'
import DashboardItem from '../../DashboardItem'
import Paging from 'Features/Paging/paging'
import SpinnerAbsolute from 'Features/Components/SpinnerAbsolute'
import { useTranslation } from 'react-i18next'
import ArchivedOrPendingArchivedThread from './ArchivedOrPendingArchivedThread'
import { getForumUnpublishedThreads } from 'Frontend/scripts/services/forums.service'
import { IForumSearchResults } from 'Frontend/scripts/models/forums.model'

interface IArchivedOrPendingArchivedThreadsProps {
  isArchived: boolean
}

const ArchivedOrPendingArchivedThreads: FunctionComponent<IArchivedOrPendingArchivedThreadsProps> = ({
  isArchived,
}) => {
  const [activePageIndex, setActivePageIndex] = useState<number>(1)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [threads, setThreads] = useState<IForumSearchResults>()
  const { t } = useTranslation()

  const changePage = (activePage: number) => {
    setActivePageIndex(activePage)
  }

  const getUnpublishedThreads = () => {
    getForumUnpublishedThreads(activePageIndex, isArchived).then((threads) => {
      setThreads(threads)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    setIsLoading(true)
    getUnpublishedThreads()
  }, [activePageIndex])
  return (
    <DashboardItem
      heading={
        isArchived ? t('dashboard.threads.unpublished-threads') : t('dashboard.threads.pending-archived-threads')
      }
    >
      <SpinnerAbsolute isLoading={isLoading} />
      {threads?.items.map((thread, index) => (
        <ArchivedOrPendingArchivedThread
          thread={thread}
          isArchived={isArchived}
          callback={() => getUnpublishedThreads()}
          key={`unpublished-thread${index}`}
        ></ArchivedOrPendingArchivedThread>
      ))}
      {(threads?.totalPages as number) > 1 && (
        <Paging
          noOfPages={threads?.totalPages as number}
          activePage={activePageIndex as number}
          callback={(activePage) => {
            changePage(activePage)
          }}
        />
      )}
    </DashboardItem>
  )
}

export default ArchivedOrPendingArchivedThreads
